import React, { useEffect, useState, useMemo } from 'react';
import apis from '../../../../apis';
import IconTip from '@/components/icon-tip';
import { Checkbox, message, Empty } from 'antd';
import { INDEX_GROUP, DEFAULT_INDEX, INDEX_GROUP_MAP } from '../real-time-data/config';
import { Chart, LineAdvance, Axis, Tooltip } from 'bizcharts';
import utils from '@/common/utils';
import { formatPrice } from '@/common/utils';
import { format } from '@/common/utils/number';

export default function (props) {
  const [data, setData] = useState();
  const [selectTag, setSelectTag] = useState(DEFAULT_INDEX);

  const changeCheckedIndex = (val) => {
    setSelectTag(val);
  };
  const dataSource = useMemo(() => getData(data, selectTag), [data, selectTag]);

  useEffect(() => {
    if (!props.filter) return;
    apis.channelEffectTrend({ ...props.filter, channelStatus: '2' }).then((res) => {
      const { ret, data, msg } = res;
      if (ret === '0') {
        setData(data);
      } else {
        message.error(msg);
        setData();
      }
    });
  }, [props.filter]);

  const scale = {
    time: {
      type: 'cat',
    },
  };

  const chart = useMemo(() => {
    return dataSource && dataSource.length ? (
      <Chart padding="auto" autoFit height={260} data={dataSource} scale={scale}>
        <LineAdvance shape="smooth" point area position="time*value" color="name" />
        <Tooltip>
          {(title, items) => {
            let item = items[0];
            return (
              <div style={{ padding: '12px 2px' }}>
                <div style={{ fontSize: '14px', color: '#0D0D0D' }}>{item.data.time}</div>
                <div style={{ fontSize: '12px', color: 'rgba(0,0,0,0.65);', marginTop: '12px' }}>
                  <span
                    style={{
                      position: 'relative',
                      background: '#2d64ff',
                      display: 'inline-block',
                      marginRight: '12px',
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      top: '-1px',
                    }}
                  ></span>
                  {item.data.name}：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{format(item.data.value, 'number_0')}
                </div>
              </div>
            );
          }}
        </Tooltip>
        <Axis
          name="value"
          label={{
            autoHide: false,
          }}
        />
      </Chart>
    ) : (
      <Empty />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSource]);
  console.log('数据格式化---------------', dataSource);
  if (!data) return null;
  return (
    // <div>
    <div className="channel-tab-card-bg">
      <div className="channel-tab-card-title">
        历史成交数据趋势
        <IconTip title="统计时间内，上线秒杀频道的商品在活动期间产生的促销成交商品金额+参与秒杀预售商品在支付定金或尾款订单中对应的金额汇总（包括定金期和尾款期），数据T+1更新" />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
        <div className="real-time-left-content">
          <div className="real-time-trend-container">
            <Checkbox.Group options={INDEX_GROUP} defaultValue={DEFAULT_INDEX} onChange={changeCheckedIndex} />
          </div>
          {chart}
        </div>

        <div className="real-time-right-content">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
            <div>已参与频道数</div>
            {data.participated && <div>共{data.participated.length}个</div>}
          </div>

          {data.participated &&
            data.participated.length &&
            data.participated.map((item, index) => {
              return (
                <div
                  className="channel-effect-trend-item"
                  onClick={() => {
                    props.setSecKill({
                      realTime: 1,
                    });
                  }}
                  key={item.channelId}
                >
                  <div className="real-time-top-name">{item.channelName}</div>
                  <div className="real-time-top-money">&gt;</div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
  function getData(data, selectTag) {
    if (!data || (data.trendList && !data.trendList.length)) return;
    const res = [];
    selectTag.map((item) => {
      data?.trendList?.map((dataItem) => {
        res.push({
          time: dataItem.dt,
          value: dataItem[item],
          name: INDEX_GROUP_MAP[item],
        });
      });
    });
    return res;
  }
}
